import { render } from "./error400Page.vue?vue&type=template&id=7312c212&scoped=true"
const script = {}

import "./error400Page.vue?vue&type=style&index=0&id=7312c212&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7312c212"]])

export default __exports__